import Request from './request';

async function day(data) {
    return Request('get', "api/top/purchases-for-day", data);
}


async function week(data) {
    return Request('get', "api/top/purchases-for-week", data);
}

async function month(data) {
    return Request('get', "api/top/purchases-for-month", data);
}

async function todos(data) {
    return Request('get', "api/top/purchases-count", data);
}

async function returnTodos(data) {
    return Request('get', "api/top/purchases-refund-count", data);
}


export default {
    day,
    week,
    month,
    todos,
    returnTodos

};